/**
 * Parse the current URL search params into initial Solr state.
 * Reads f[facet_id]=value1,value2, sort=field:order, and q=searchterm.
 * @returns {{ filters: object|null, sorting: string, searchQuery: string }}
 */
const parseUrlState = () => {
  if (typeof window === "undefined") {
    return { filters: null, sorting: "", searchQuery: "" };
  }

  const params = new URLSearchParams(window.location.search);
  const filters = {};
  let hasFilters = false;

  params.forEach((value, key) => {
    const match = key.match(/^f\[(.+)\]$/);
    if (match) {
      const filterId = match[1];
      filters[filterId] = value.split(",").filter(Boolean);
      hasFilters = true;
    }
  });

  return {
    filters: hasFilters ? filters : null,
    sorting: params.get("sort") || "",
    searchQuery: params.get("q") || "",
  };
};

export default parseUrlState;
